import { BasicRequest } from "./basicRequest";

export class ApproveMoovStepInstanceRequest extends BasicRequest{
    public moovStepInstanceId!:number;

    constructor(){
        super();
    }
}